import type { EditorConfig } from "./types";
import {
  Heading,
  Paragraph,
  Quote,
  Verse,
  Image,
  Gallery,
  Divider,
  Callout,
  Video,
  Embed,
  List,
  Code,
  Spacer,
  Button,
  Hero,
  TwoColumn,
  Stat,
  Cta,
  Table,
  Accordion,
  Columns,
  Audio,
  Pdf,
  Footnotes,
  Math,
  Row,
  registerRowSerialisers,
} from "./blocks";

/**
 * The block palette available to article authors. Documents will get a similar
 * config later (with file-attachment + downloadable widgets), but most of the
 * editorial blocks here will carry over.
 */
const articleBlockTypes = [
  Heading,
  Paragraph,
  List,
  Quote,
  Verse,
  Callout,
  Footnotes,
  Image,
  Gallery,
  Video,
  Audio,
  Pdf,
  Embed,
  Code,
  Math,
  Hero,
  TwoColumn,
  Columns,
  Row,
  Table,
  Accordion,
  Stat,
  Cta,
  Button,
  Divider,
  Spacer,
];

// Wire Row's HTML/text serialisers up after the registry is built — Row
// looks up sibling block types when serialising each of its cells, and
// can't import them directly without a circular dependency.
registerRowSerialisers(articleBlockTypes);

export const articleEditorConfig: EditorConfig = {
  blockTypes: articleBlockTypes,
  paletteOrder: [
    // Text
    "heading",
    "paragraph",
    "list",
    "quote",
    "callout",
    "verse",
    "code",
    "footnotes",
    // Media
    "image",
    "gallery",
    "video",
    "audio",
    "pdf",
    "embed",
    // Special
    "math",
    // Layout
    "hero",
    "two-column",
    "columns",
    "table",
    "accordion",
    "stat",
    "cta",
    "button",
    "divider",
    "spacer",
  ],
};
